export type TextEllipsisProps = {
    className: string;
    height: number;
    children: React.ReactNode;
}

export default function TextEllipsis({ className, height, children }: TextEllipsisProps) {
    return (
        <div className="relative" style={{ height: `${height}px` }}>
            <div className={`absolute left-0 top-0 w-full h-full text-ellipsis overflow-hidden text-nowrap flex-nowrap ${className}`}>
                {children}
            </div>
        </div>
    );
}